import React from 'react'

const NotificationGreenSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 21.5 20.611'
    >
      <path
        id='announcement-02-svgrepo-com'
        d='M4,14l1.575,6.3c.044.177.066.266.093.343A2,2,0,0,0,7.4,21.993c.081.007.173.007.355.007.229,0,.343,0,.439-.009a2,2,0,0,0,1.8-1.8c.009-.1.009-.211.009-.439V5.5m8.5,8a3.5,3.5,0,1,0,0-7m-8.25-1H6.5a4.5,4.5,0,1,0,0,9h3.75a13.115,13.115,0,0,1,5.594,1.856c.972.53,1.459.8,1.777.756a.946.946,0,0,0,.692-.411c.187-.261.187-.783.187-1.827V5.126c0-1.044,0-1.566-.187-1.827a.946.946,0,0,0-.692-.411c-.318-.039-.8.226-1.777.756A13.116,13.116,0,0,1,10.25,5.5Z'
        transform='translate(-1.25 -2.139)'
        fill='none'
        stroke='#205c42'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  )
}

export default NotificationGreenSvg
